/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShadowSubsystemOutcome } from './ShadowSubsystemOutcome';
import {
    ShadowSubsystemOutcomeFromJSON,
    ShadowSubsystemOutcomeFromJSONTyped,
    ShadowSubsystemOutcomeToJSON,
    ShadowSubsystemOutcomeToJSONTyped,
} from './ShadowSubsystemOutcome';
import type { ShadowSubsystemAction } from './ShadowSubsystemAction';
import {
    ShadowSubsystemActionFromJSON,
    ShadowSubsystemActionFromJSONTyped,
    ShadowSubsystemActionToJSON,
    ShadowSubsystemActionToJSONTyped,
} from './ShadowSubsystemAction';
import type { ShadowSubsystemScoring } from './ShadowSubsystemScoring';
import {
    ShadowSubsystemScoringFromJSON,
    ShadowSubsystemScoringFromJSONTyped,
    ShadowSubsystemScoringToJSON,
    ShadowSubsystemScoringToJSONTyped,
} from './ShadowSubsystemScoring';
import type { ShadowSubsystemAuditStep } from './ShadowSubsystemAuditStep';
import {
    ShadowSubsystemAuditStepFromJSON,
    ShadowSubsystemAuditStepFromJSONTyped,
    ShadowSubsystemAuditStepToJSON,
    ShadowSubsystemAuditStepToJSONTyped,
} from './ShadowSubsystemAuditStep';

/**
 * 
 * @export
 * @interface ShadowSubsystemResult
 */
export interface ShadowSubsystemResult {
    /**
     * 
     */
    outcome: ShadowSubsystemOutcome;
    /**
     * 
     */
    reason: string;
    /**
     * 
     */
    next_step?: ShadowSubsystemAction;
    /**
     * 
     */
    missing_information?: Array<string>;
    /**
     * 
     */
    scoring?: ShadowSubsystemScoring;
    /**
     * 
     */
    audit_steps?: Array<ShadowSubsystemAuditStep>;
}



/**
 * Check if a given object implements the ShadowSubsystemResult interface.
 */
export function instanceOfShadowSubsystemResult(value: object): value is ShadowSubsystemResult {
    if (!('outcome' in value) || value['outcome'] === undefined) return false;
    if (!('reason' in value) || value['reason'] === undefined) return false;
    return true;
}

export function ShadowSubsystemResultFromJSON(json: any): ShadowSubsystemResult {
    return ShadowSubsystemResultFromJSONTyped(json, false);
}

export function ShadowSubsystemResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShadowSubsystemResult {
    if (json == null) {
        return json;
    }
    return {
        
        'outcome': ShadowSubsystemOutcomeFromJSON(json['outcome']),
        'reason': json['reason'],
        'next_step': json['next_step'] == null ? undefined : ShadowSubsystemActionFromJSON(json['next_step']),
        'missing_information': json['missing_information'] == null ? undefined : json['missing_information'],
        'scoring': json['scoring'] == null ? undefined : ShadowSubsystemScoringFromJSON(json['scoring']),
        'audit_steps': json['audit_steps'] == null ? undefined : ((json['audit_steps'] as Array<any>).map(ShadowSubsystemAuditStepFromJSON)),
    };
}

export function ShadowSubsystemResultToJSON(json: any): ShadowSubsystemResult {
    return ShadowSubsystemResultToJSONTyped(json, false);
}

export function ShadowSubsystemResultToJSONTyped(value?: ShadowSubsystemResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'outcome': ShadowSubsystemOutcomeToJSON(value['outcome']),
        'reason': value['reason'],
        'next_step': ShadowSubsystemActionToJSON(value['next_step']),
        'missing_information': value['missing_information'],
        'scoring': ShadowSubsystemScoringToJSON(value['scoring']),
        'audit_steps': value['audit_steps'] == null ? undefined : ((value['audit_steps'] as Array<any>).map(ShadowSubsystemAuditStepToJSON)),
    };
}

